module.exports = __webpack_public_path__ + "img/1fie-e-yu'udo'.d07ddb53.jpg";